import { PrescribedItem } from './../../../../types/prescription'

export const hasUnusualQuantity = (prescribedItem: PrescribedItem) =>
  (prescribedItem.isPBS || prescribedItem.isRPBS) &&
  (prescribedItem.quantity > Number(prescribedItem.maximumQuantity) ||
    prescribedItem.numberOfRepeatsAuthorised > prescribedItem.maximumRepeats)
